import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";

import logo from "assets/images/heylime-logo.png";

const InvalidURL = () => {
  const history = useHistory();
  const { currentUser } = useSelector((state) => state.gameReducer);

  const handleClick = () => {
    if (isEmpty(currentUser)) {
      history.push("/signup");
    } else {
      history.push("/");
    }
  };

  return (
    <div className="company-name-main pricing-main">
      <div className="company-name-header">
        <div className="logo" onClick={() => history.push("/")}>
          <img src={logo} alt="logo" />
        </div>
      </div>

      <div className="invalid-url-main">
        <div className="invalid-url-content">
          <div className="invalid-text">
            <h2>Invalid Page</h2>
            <p>We weren’t able to find the page you were trying to reach.</p>
          </div>

          <button onClick={handleClick}>
            {isEmpty(currentUser) ? "Sign Up / Login" : "Browse Library"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvalidURL;
